import script from "./VitaRightBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./VitaRightBar.vue?vue&type=script&lang=ts&setup=true"

import "./VitaRightBar.vue?vue&type=style&index=0&id=3c87dc7a&lang=scss"

const __exports__ = script;

export default __exports__